import classnames from 'classnames'

import { Icon } from '../ui/bootstrap/bootstrap'

import styles from './TogglesField.sass'

// Controlled multi-select rendered as toggleable chips.
// value is an array of option values (kept as strings).
export const TogglesField = ({ value, onChange, options = [] }) => {
  const current = (value || []).map(String)

  const toggle = id => {
    if (current.indexOf(id) == -1)
      onChange([ ...current, id ])
    else
      onChange(current.filter(other => other != id))
  }

  return (
    <div className={styles.toggles}>
      {options.map(({ value, label }) => {
        const id = String(value)
        const active = current.indexOf(id) != -1
        const classes = classnames(styles.toggle, {
          [styles.active]: active
        })

        return (
          <div
            key={id}
            className={classes}
            onClick={() => toggle(id)}
          >
            {active && <Icon icon="check" />}
            <span className={styles.label}>
              {label}
            </span>
          </div>
        )
      })}
    </div>
  )
}
